const moduleoptioncoursetypes = {
	title: "Modul valg - Kompetanse",
	new_moduleoptioncoursetype: "Nytt modul valg - Kompetanse",
	edit_moduleoptioncoursetype: "Endre modul valg - Kompetanse: {name}",
	id: "ID",
	moduleoption_id: "Modul valg",
	coursetype_id: "Kompetansegruppe",
	coursetypegroup_id: "Kompetanseområde",
	name: "Navn",
	price: "Pris",
	comment: "Kommentar",
};
export default moduleoptioncoursetypes;